import LMS from "../assets/cricket.jpg";
import SRI from "../assets/Festival.jpg";
import ETA from "../assets/jhandaburja.jpg";
import movies from "../assets/h.jpg";
import myport from "../assets/emoji.jpg";
import movie from "../assets/chat.jpg";

export const Data = [
  {
    id: 1,
    title: "Events",
    image: LMS,
  },
  {
    id: 2,
    title: "Events",
    image: SRI,
  },
  {
    id: 3,
    title: "Games",
    image: ETA,
  },
  {
    id: 4,
    title: "Games",
    image: movies,
  },
  {
    id: 5,
    title: "Gifting",
    image: myport,
  },
  {
    id: 6,
    title: "Chatting",
    image: movie,
  },
];
